/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Grid } from '@mui/material'

import { 
  useGET_setupOptionsQuery,
  usePOST_setupOptionEnableMutation,
  usePOST_setupOptionDisableMutation 
} from 'redux/api/setupApi'

import { Form, Formik } from 'formik'
import CheckboxField from 'components/atoms/fields/CheckboxField'

const SyllabusSetupMainForm: FC = () => {
  const { t } = useTranslation()
  
  const { data: setupData } = useGET_setupOptionsQuery()
  const [enableOption, {isLoading: isEnableLoading, isSuccess: isEnableSuccess, error: enableError}] = usePOST_setupOptionEnableMutation()
  const [disableOption, {isLoading: isDisableLoading, isSuccess: isDisableSuccess, error: disableError}] = usePOST_setupOptionDisableMutation()


  const setupOptions = [
    {key: 'syllabus_subject', label: t('common.subject')},
    {key: 'syllabus_grade', label: t('common.grade-level')},
    {key: 'syllabus_highlights', label: t('goalbank.highlights')},
    {key: 'syllabus_student_learning_objectives', label: t('goalbank.slo')},
    {key: 'syllabus_measures', label: t('goalbank.measures')},
    {key: 'syllabus_topics', label: t('goalbank.topics')},
    {key: 'syllabus_skills', label: t('goalbank.skills')},
    {key: 'syllabus_course_chapters', label: t('goalbank.units')},
    {key: 'syllabus_fluencies', label: t('goalbank.fluencies')},
    {key: 'syllabus_practices', label: t('goalbank.practices')},
    {key: 'syllabus_success_criterias', label: t('goalbank.success-criteria')}
  ]

  const serverValues = setupData ? {
    syllabus_curriculum: [{
      key: 'syllabus_curriculum',
      label: t('common.curriculum'),
      is_enabled: setupData.filter(s => s.slug == 'syllabus_curriculum' && s.is_enabled).length == 1
    }],
    options:
      setupOptions.map(o => {
        return {
          ...o,
          is_enabled: setupData.filter(s => s.slug == o.key && s.is_enabled).length == 1
        }
      })
  } : null

  
  return (

    <>{serverValues &&
    <Formik
      enableReinitialize
      initialValues={serverValues}
      onSubmit={(values) => {
      }}
    >
      {
        ({ values, setFieldValue, errors }) => 
        <Form>

          <Grid rowSpacing={4} columnSpacing={4} container alignSelf='baseline' mb={2}>
              <Grid item xs={12} md={4} className="setup-section-title">
                <CheckboxField
                  isSwitch={true}
                  hasLine={true}
                  index={0}
                  valueSelector='is_enabled'
                  fieldProps={{
                    label: values.syllabus_curriculum[0].label,
                    name: `syllabus_curriculum[0]`
                  }} 
                  onChange={(value)=> {
                    if(value.is_enabled)enableOption(values.syllabus_curriculum[0].key)
                    else disableOption(values.syllabus_curriculum[0].key)
                  }}
                />
              </Grid>
          </Grid>
          
          {values.syllabus_curriculum[0].is_enabled &&
            <Grid rowSpacing={4} columnSpacing={4} container alignSelf='baseline'>          
              {values["options"].map((option,index) => 
                <Grid item xs={12} md={4} key={index}>
                  <CheckboxField 
                    isSwitch={true}
                    hasLine={true}
                    index={index}
                    valueSelector='is_enabled'
                    fieldProps={{
                      label: option.label,
                      name: `options[${index}]`
                    }} 
                    onChange={(value)=> {
                      if(value.is_enabled)enableOption(option.key)
                      else disableOption(option.key)
                    }}
                  />
                </Grid>
                  )}
            </Grid>
          }
          
        </Form>
      }
    </Formik>
    }</>
  )
}
export default SyllabusSetupMainForm

